import useActionsPaymentMethodAdvancedForm from './useActionsPaymentMethodAdvancedForm'

export default useActionsPaymentMethodAdvancedForm
